<div class="fields" layout="row">
    <span class="labels" style="display: inline">
        @if (commonDataService.isOneTime) {
            @for (field of ticket.fields; track field) {
                <span class="label"> {{ field.name }}: {{ field.transformedValue || field.value }} </span>
            }
        } @else {
            @for (field of ticket.fields; track field.id) {
                <a
                    class="label label-link label--bg-color-white"
                    tooltip="{{ 'Click to view all tickets with such fields value' | translate }}"
                    container="body"
                    [routerLink]="['/', commonDataService.communityName, 'tickets']"
                    [adaptivePosition]="false"
                    [queryParams]="{ ticketId: ticket.id, fields: field | encodedParamValue }">
                    {{ field.name }}: {{ field.transformedValue || field.value }}
                </a>
            }
        }
    </span>

    <span>
        <span
            class="d-inline-block"
            container="body"
            [adaptivePosition]="false"
            [tooltip]="copyFieldsTooltip"
            #customFieldsTooltip="bs-tooltip"
            (click)="setIsCopied(customFieldsTooltip)">
            <button class="btn btn-icon" ngxClipboard [cbContent]="clipboardData">
                <sb-inline-svg
                    class="icon"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'"></sb-inline-svg>
            </button>
        </span>

        @if (!commonDataService.isOneTime) {
            <button
                class="btn btn-icon"
                (click)="openEditFieldsTab()"
                tooltip="{{ 'Click to edit fields' | translate }}"
                container="body">
                <sb-inline-svg
                    class="icon"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'"></sb-inline-svg>
            </button>
        }
    </span>
</div>
